module.exports = __webpack_public_path__ + "static/media/header_gray_transparent_cut.a90723f3.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Section/header_gray_transparent_cut.png
 ** module id = 177
 ** module chunks = 0
 **/